import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const INVITE_STORAGE_KEY = 'ringen-invite'

export function hasValidInvite(): boolean {
  return !!localStorage.getItem(INVITE_STORAGE_KEY)
}

export function getInviteCode(): string | null {
  return localStorage.getItem(INVITE_STORAGE_KEY)
}

export default function InvitePage() {
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const res = await fetch('/api/auth/validate-invite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code.trim() }),
      })

      if (res.ok) {
        localStorage.setItem(INVITE_STORAGE_KEY, code.trim())
        navigate('/login')
      } else {
        setError('Invalid invite code')
      }
    } catch {
      setError('Failed to validate code')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-lg shadow-lg border border-slate-200 p-8">
          <h1 className="text-3xl font-bold text-center mb-2 text-slate-900">Ringen</h1>
          <p className="text-center text-slate-500 text-sm mb-8">Enter your invite code to continue</p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Invite code"
              required
              autoFocus
              className="w-full px-4 py-3 border border-slate-300 rounded-md text-center text-lg tracking-wider focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent"
            />
            <button
              type="submit"
              disabled={loading || !code.trim()}
              className="w-full bg-slate-900 text-white py-3 px-4 rounded-md font-medium hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? 'Checking...' : 'Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
